import { createNamespace } from '../utils';
import Icon from '../icon';

var _createNamespace = createNamespace('result'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

export default createComponent({
  props: {
    type: String,
    inline: Boolean,
    icon: String,
    title: String,
    tip: String,
    color: String,
    textColor: String
  },
  computed: {
    genTitle: function genTitle() {
      return this.title || (this.type === 'fail' ? '操作失败' : this.type === 'success' ? '操作成功' : '');
    },
    genIcon: function genIcon() {
      return this.icon || (this.type === 'fail' ? 'warning' : this.type === 'success' ? 'checked' : '');
    },
    genIconColor: function genIconColor() {
      return this.color || (this.type === 'fail' ? '#ff5f4e' : this.type === 'success' ? '#32AE57' : '');
    }
  },
  render: function render() {
    var h = arguments[0];
    return h("div", {
      "attrs": {
        "role": "result"
      },
      "class": [bem({
        inline: this.inline
      }), 'van-clearfix']
    }, [this.slots('icon') || h(Icon, {
      "class": bem('icon'),
      "attrs": {
        "color": this.genIconColor,
        "name": this.genIcon
      }
    }), h("div", {
      "class": bem('title'),
      "style": {
        color: this.textColor
      }
    }, [this.genTitle]), this.tip && h("div", {
      "class": [bem('tip'), 'van-multi-ellipsis--l2']
    }, [this.tip]), this.slots('default')]);
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant-green/es/result/index.js
// module id = null
// module chunks = 